import Pusher from 'pusher-js';
import { PUSHER_KEY, PUSHER_CLUSTER } from './pusher';

export const pusher = new Pusher(PUSHER_KEY, {
  cluster: PUSHER_CLUSTER,
  encrypted: true,
});

export const UPDATE_UI_CHANNEL = pusher.subscribe('update-ui');
